/**
 * Service that wraps around the masterData object, that spesializes on ports.
 * Used for utility methods.
 */
var VRC = VRC || {};

VRC.PortManager = (function () {
	var ports = [];

	var init = function () {
		ports = g_master_data.GetList('port_list');
	};
	var isRig = function (port) {
		return port.type === 'rig';
	};

	var isHarboursOrBase = function (port) {
		return port.type === 'base' || port.type === 'harbour';
	};

	var getPorts = function () {
		return ports;
	};

	var getRigs = function () {
		return ports.filter(isRig);
	};

	var getHarboursAndBases = function () {
		return ports.filter(isHarboursOrBase);
	};

	return {
		init: init,
		getPorts: getPorts,
		getRigs: getRigs,
		getHarboursAndBases: getHarboursAndBases
	}
})();